"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useReactionSelectorStyles = exports.reactionSelectorVars = exports.reactionSelectorCommon = void 0;
var _createUseStyles = _interopRequireDefault(require("../../themes/createUseStyles"));
var _commonProps = require("../../utils/vars/commonProps");
var _initVars = _interopRequireDefault(require("../../utils/vars/initVars"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @copyright
 * Copyright (c) 2025 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var reactionSelectorCommon = exports.reactionSelectorCommon = _commonProps.defaultCommonProps;
var reactionSelectorVars = exports.reactionSelectorVars = (0, _initVars.default)({
  applied: reactionSelectorCommon,
  variables: [{
    key: "rootBackgroundColor",
    canHaveColor: true
  }, {
    key: "size"
  }, {
    key: "invertedSize"
  }]
});
var styles = function styles(theme) {
  return {
    variables: reactionSelectorVars.styles,
    root: {
      backgroundColor: reactionSelectorVars.get("rootBackgroundColor", theme.colors.baseContrast030),
      padding: [theme.spacing.base, theme.spacing.base / 2, 0],
      borderRadius: 16,
      boxShadow: "0 0 0 1px rgba(0, 0, 0, .05), 0 1px 2px rgba(0, 0, 0, .15)",
      display: "flex"
    },
    reaction: {
      boxSizing: "content-box",
      width: reactionSelectorVars.get("size"),
      padding: theme.spacing.base / 2,
      position: "relative",
      textAlign: "center",
      "&:hover": {
        "& > $label": {
          // eslint-disable-next-line @atg/css-rtl-support
          transform: "translateX(-50%) translateY(-10px)",
          opacity: "1"
        },
        "& > $icon": {
          transform: "scale(1.3)"
        }
      }
    },
    label: {
      borderRadius: "14px",
      fontSize: "11px",
      padding: "4px 7px 3px",
      top: reactionSelectorVars.get("invertedSize"),
      background: "rgba(0,0,0,.8)",
      color: "#fff",
      position: "absolute",
      fontWeight: "bold",
      textTransform: "capitalize",
      // eslint-disable-next-line @atg/css-rtl-support
      left: "50%",
      // eslint-disable-next-line @atg/css-rtl-support
      transform: "translateX(-50%)",
      transition: "200ms transform cubic-bezier(0.23, 1, 0.32, 1)",
      opacity: "0",
      whiteSpace: "nowrap"
    },
    icon: {
      cursor: "pointer",
      transition: "200ms transform cubic-bezier(0.23, 1, 0.32, 1)",
      "& svg": {
        fill: theme.colors.baseContrast060
      }
    },
    total: {
      fontSize: "11px",
      cursor: "default",
      color: theme.colors.baseContrast090
    }
  };
};
var useReactionSelectorStyles = exports.useReactionSelectorStyles = (0, _createUseStyles.default)(styles, {
  name: "ReactionSelector"
});